import './view-newsletter-distribution.component.css';
import * as angular from 'angular';

const viewNewsletterDistributionConfig = {
    selector: 'mwViewNewsletterDistribution',
    bindings: {
        distributionId: '<',
        subjectLine: '<'
    },
    template:
        `<md-dialog class="view-nld mw-flexi-modal" aria-label="Fleximodal" layout="column">
            <md-toolbar class="view-nld__toolbar" layout="column">
                <div class="md-toolbar-tools">
                    <md-button 
                        class="md-icon-button view-nld__toolbar-button view-nld__toolbar-button" 
                        ng-click="$ctrl.cancel()">
                        
                        <md-icon md-svg-icon="navigation:ic_arrow_back_24px" aria-label="{{'outputs__general--close-dialog'|translate}}"></md-icon>
                    </md-button>
                    <h2 class="view-nld__toolbar-title">{{::$ctrl.subjectLine}}</h2>
                    <div flex></div>
                    <md-button 
                        class="md-icon-button view-nld__toolbar-button" 
                        ng-if="$ctrl.haveNewsletter"
                        ng-click="$ctrl.PreviewLinkDialogService.show($event, $ctrl.linkToHtml)">
                        
                        <md-tooltip md-direction="bottom">
                            <span translate>newsletters__dialog-title--nld-html</span>
                        </md-tooltip>
                        <md-icon md-svg-icon="content:ic_link_24px" aria-label="{{'newsletters__dialog-title--nld-html'|translate}}"></md-icon>
                    </md-button>
                    <md-button 
                        class="md-icon-button view-nld__toolbar-button" 
                        ng-if="$ctrl.haveNewsletter"
                        ng-click="$ctrl.SendAgainDialogService.sendAgain($event, $ctrl.distributionId)">
                        
                        <md-tooltip md-direction="bottom">
                            <span translate>newsletters__tooltip--send-again</span>
                        </md-tooltip>
                        <md-icon md-svg-icon="content:ic_send_24px" aria-label="{{'Send'|translate}}"></md-icon>
                    </md-button>
                </div>
            </md-toolbar>
            <md-dialog-content layout="column" flex>
                <iframe id="view-distribution-iframe" class="view-nld__iframe" flex></iframe>
            </md-dialog-content>
        </md-dialog>`,
    controller: null
};

class ViewNewsletterDistributionComponent {
    distributionId: string;
    haveNewsletter: boolean;
    linkToHtml: string;
    constructor(
        private $translate,
        private $mdDialog,
        private $timeout,
        private NewsletterDistributionService,
        private SendAgainDialogService,
        private PreviewLinkDialogService,
        private CoreCompanyService,
        private MW_NEWSLETTER_API_DOMAIN,
        private MW_NEWSLETTER_API_PORT
    ) {
        'ngInject';
        this.haveNewsletter = false;
    }

    $onInit() {
        const companyId = this.CoreCompanyService.getId();
        const newsletterAPIUrl = this.MW_NEWSLETTER_API_DOMAIN + (this.MW_NEWSLETTER_API_PORT !== ''? ':' + this.MW_NEWSLETTER_API_PORT : '');
        this.linkToHtml = newsletterAPIUrl + '/' + companyId + '/newsletter/distribution/' + this.distributionId + '/html';
        this.loadNewsletter();
    }

    loadNewsletter() {
        this.NewsletterDistributionService.getNewsletterDistributionHTML(this.linkToHtml)
            .then(
                (response) => {
                    if (response.data) {
                        this.haveNewsletter = true;
                        this.displayNewsletter(response.data);
                    } else {
                        this.showNotFoundDialog();
                    }
                },
                () => this.showNotFoundDialog()
            );
    }

    displayNewsletter(html) {
        this.$timeout(() => {
            let iframe      = document.getElementById('view-distribution-iframe'),
                htmlContent = document.createElement('html'),
                anchorTags, i;

            // Create DOM from htmlText and get all the anchor tags
            htmlContent.innerHTML = html;
            anchorTags = htmlContent.getElementsByTagName('a');

            // Set target=_blank on all the anchor tags
            for (i = 0; i < anchorTags.length; i++) {
                anchorTags[i].setAttribute('target', '_blank');
            }

            // Append content to the iframe
            iframe.contentWindow.document.open();
            iframe.contentWindow.document.write(htmlContent.innerHTML);
            iframe.contentWindow.document.close();
        });
    }

    showNotFoundDialog() {
        this.$mdDialog.show(
            this.$mdDialog.mwAlert()
                .title(this.$translate.instant('mw-newsletter__error-title--no-newsletter'))
                .textContent(this.$translate.instant('newsletters__error-text--newsletter-preview-not-found'))
                .ok(this.$translate.instant('OK'))
        )
            .then(() => {
                this.cancel();
            });
    }

    cancel() {
        this.$mdDialog.hide();
    }
}

viewNewsletterDistributionConfig.controller = ViewNewsletterDistributionComponent;

export {
    viewNewsletterDistributionConfig,
    ViewNewsletterDistributionComponent as default
}



/** WEBPACK FOOTER **
 ** ./apps-ts/outputs/src/app/newsletter-distributions/view-newsletter-distribution/view-newsletter-distribution.component.ts
 **/